module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('h1', {
    staticClass: "Prelims-head",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("the Author")]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/CLOUD-about-author-photo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Prelims-main",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v("Sophie Cloud is a poet and writer of historical fiction."), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-GB"
    }
  }, [_vm._v(" It’s Murder!")]), _vm._v(" is Sophie’s fourth book to be published. She resides in London with her family."), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a82b52d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398432048_EPUB.vue
// module id = 57
// module chunks = 0